/*

Template:  Webmin - Bootstrap 4 & Angular 5 Admin Dashboard Template
Author: potenzaglobalsolutions.com
Design and Developed by: potenzaglobalsolutions.com

NOTE:

*/

(function ($) {
    "use strict";
    // Line Stacked

    //Check if function exists
    $.fn.exists = function () {
        return this.length > 0;
    };

    var dataJsonLinea = [];
    var dataJsonSubLinea = [];

    var matriz = [];
    var matriz2 = "";
    var data3 = "";


    var desde = $("#desde").val();
    var hasta = $("#hasta").val();

    $.ajax({
        url: "./ventasublinea",
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        type: "POST",
        data: { desde: desde, hasta: hasta },
        beforeSend: function () {
            console.log("cargando2222");
        },
        success: function (dataResp) {

            var data = "";
            var data3 = "";
            var lineasArr = [];
            var lineas = [];
            var sublineas = [];
            var suma = 0;

            var subArrayTemp = [];
            var a = 0;

            var ii = 0;
            $.each(dataResp, function (i, item) {

                if (lineasArr.indexOf(item.Linea) !== -1) {

                } else {


                    lineasArr.push(item.Linea);

                    lineas[a] = ({ name: item.Linea, y: 11, drilldown: item.Linea });
                    sublineas[a] = ({ id: item.Linea, type: 'column', data: [] });
                    a++;

                    if (i == 0) {
                        ii = 0;
                    } else {
                        ii++;
                        suma = 0;
                    }
                }
                suma = suma + item.Importe;
                lineas[ii].y = suma;
                sublineas[ii].data.push([item.Sub_Linea, item.Importe]);


            });
            console.log(lineas);
            console.log(sublineas);

            var data2 = JSON.stringify(lineas);
            var data = JSON.parse(data2);

            var data4 = JSON.stringify(sublineas);
            var data3 = JSON.parse(data4);


            // Chart
            //var dataJson = '[{"name":"January","y":1398,"drilldown":"January"},{"name":"February","y":1384,"drilldown":"February"},{"name":"March","y":1135,"drilldown":"March"},{"name":"April","y":1283,"drilldown":"April"},{"name":"May","y":1352,"drilldown":"May"}]';

            //var data = JSON.parse(dataJson);
            Highcharts.setOptions({
                lang: {
                    thousandsSep: ','
                }
            });

            var option = {
                chart: {
                    renderTo: 'container',
                    type: 'column',
                    events: {

                    }
                },
                title: {
                    text: ''
                },
                xAxis: {
                    type: 'category'
                },
                yAxis: [{
                    title: {
                        text: 'Importe'
                    },
                    stackLabels: {
                        enabled: true,
                        style: {
                            fontWeight: 'bold',
                            color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
                        }
                    }
                }],
                legend: {
                    align: 'right',
                    x: -30,
                    verticalAlign: 'top',
                    y: 25,
                    floating: true,
                    backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
                    borderColor: '#CCC',
                    borderWidth: 1,
                    shadow: false
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        borderWidth: 0,
                        dataLabels: {
                            enabled: false,
                            format: '{point.y:1f}',
                        }
                    }
                },
                tooltip: {
                    headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                    pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:1f}</b> <br/>'
                },
                series: [{
                    name: 'Línea',
                    colorByPoint: true,
                    data: data
                }],
                drilldown: {
                    series: data3
                },
                credits: { enabled: false }

            };

            var chart = new Highcharts.Chart(option);





        }
    });





    /*************************
      Line Chart
    *************************/
    var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var config = {
        type: 'line',
        data: {
            labels: [
                'Enero',
                'Febrero',
                'Marzo',
                'Abril',
                'Mayo',
                'Junio',
                'Julio',
                'Agosto',
                'Septiembre',
                'Octubre',
                'Noviembre',
                'Diciembre'
            ],
            datasets: [{
                label: "2017",
                fill: false,
                borderColor: window.chartColors.yellow,
                backgroundColor: window.chartColors.yellow,
                data: [],
            }, {
                label: "2018",
                fill: false,
                borderColor: window.chartColors.blue,
                backgroundColor: window.chartColors.blue,
                data: [],
            }, {
                label: "2019",
                fill: false,
                borderColor: window.chartColors.green,
                backgroundColor: window.chartColors.green,
                data: [],
            }]
        },
        options: {
            responsive: true,
            legend: {
                position: 'top',
            },
            title: {
                display: false,
                text: 'Chart.js Bar Chart'
            },
            animation: {
                animateScale: true,
                animateRotate: true
            }
        }
    };

    /*************************
         Line Styles
    *************************/
    var config2 = {
        type: 'line',
        data: {
            labels: [],
            datasets: [{
                label: "",
                fill: false,
                backgroundColor: window.chartColors.blue,
                borderColor: window.chartColors.blue,
                data: [

                ]
            }, {
                label: "",
                fill: false,
                backgroundColor: window.chartColors.green,
                borderColor: window.chartColors.green,
                data: [

                ]
            },
            {
                label: "",
                fill: false,
                backgroundColor: window.chartColors.yellow,
                borderColor: window.chartColors.yellow,
                data: [

                ]
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            title: {
                display: false,
                text: 'Line Chart - Line styles'
            },
            tooltips: {
                mode: 'index',
                intersect: false,
            },
            hover: {
                mode: 'nearest',
                intersect: true
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Línea'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Cantidad'
                    }
                }]
            },
            animation: {
                animateScale: true,
                animateRotate: true
            }

        }
    };

var configWeddingChart = {
    type: 'line',
    data: {
        labels: [],
        datasets: [
            {
                label: "",
                fill: false,
                backgroundColor: window.chartColors.blue,
                borderColor: window.chartColors.blue,
                data: []
            }, {
                label: "",
                fill: false,
                backgroundColor: window.chartColors.green,
                borderColor: window.chartColors.green,
                data: []
            },
        ]
    },
    options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
            display: false,
            text: 'Line Chart - Line styles'
        },
        tooltips: {
            mode: 'index',
            intersect: false
        },
        hover: {
            mode: 'nearest',
            intersect: true
        },
        scales: {
            xAxes: [
                {
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Línea'
                    }
                }
            ],
            yAxes: [
                {
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Cantidad'
                    }
                }
            ]
        },
        animation: {
            animateScale: true,
            animateRotate: true
        }

    }
}
var configWeddingBar = {
    "type": "bar",
    "data": {
      "labels": [],
      "datasets": [
        {
          "label": "",
          "data": [],
          "fill": false,
          "backgroundColor": [],
          "borderColor": [],
          "borderWidth": 1
        },
        {
            "label": "",
            "data": [],
            "fill": false,
            "backgroundColor": [],
            "borderColor": [],
            "borderWidth": 1
          }
      ]
    },
    "options": {
      "scales": {
        "yAxes": [
          {
            "ticks": {
              "beginAtZero": true
            }
          }
        ]
      }
    }
  }

    /*************************
         doughnut
    *************************/
    var config3 = {
        type: 'pie',
        data: {
            datasets: [{
                data: [],
                backgroundColor: [],
                label: []
            }],
            labels: []
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                position: 'bottom',
            },
            title: {
                display: false,
                text: 'Doughnut Chart'
            },
            animation: {
                animateScale: true,
                animateRotate: true
            }
        }
    };


    /*************************
            combo
    *************************/
    var timeFormat = 'MM/DD/YYYY HH:mm';
    function newDateString(days) {
        return moment().add(days, 'd').format(timeFormat);
    }

    var color = Chart.helpers.color;


    /*************************
           Custom Points
   *************************/
    var customTooltips = function (tooltip) {
        $(this._chart.canvas).css("cursor", "pointer");
        var positionY = this._chart.canvas.offsetTop;
        var positionX = this._chart.canvas.offsetLeft;
        $(".chartjs-tooltip").css({
            opacity: 0,
        });
        if (!tooltip || !tooltip.opacity) {
            return;
        }
        if (tooltip.dataPoints.length > 0) {
            tooltip.dataPoints.forEach(function (dataPoint) {
                var content = [dataPoint.xLabel, dataPoint.yLabel].join(": ");
                var $tooltip = $("#tooltip-" + dataPoint.datasetIndex);

                $tooltip.html(content);
                $tooltip.css({
                    opacity: 1,
                    top: positionY + dataPoint.y + "px",
                    left: positionX + dataPoint.x + "px",
                });
            });
        }
    };
    var color = Chart.helpers.color;
    var lineChartData = {
        labels: ["January", "February", "March", "April", "May", "June", "July"],
        datasets: [{
            label: "My First dataset",
            backgroundColor: color(window.chartColors.red).alpha(0.2).rgbString(),
            borderColor: window.chartColors.red,
            pointBackgroundColor: window.chartColors.red,
            data: [
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor()
            ]
        }, {
            label: "My Second dataset",
            backgroundColor: color(window.chartColors.blue).alpha(0.2).rgbString(),
            borderColor: window.chartColors.blue,
            pointBackgroundColor: window.chartColors.blue,
            data: [
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor()
            ]
        }]
    };

    /*************************
         Chart Basic
   *************************/
    var config6 = {
        type: 'line',
        data: {
            labels: ["January", "February", "March", "April", "May", "June", "July"],
            datasets: [{
                label: "My First dataset",
                backgroundColor: window.chartColors.red,
                borderColor: window.chartColors.red,
                data: [
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor()
                ],
                fill: false,
            }, {
                label: "My Second dataset",
                fill: false,
                backgroundColor: window.chartColors.blue,
                borderColor: window.chartColors.blue,
                data: [
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor()
                ],
            }]
        },
        options: {
            maintainAspectRatio: false,
            responsive: true,
            title: {
                display: true,
                text: 'Line Chart - Basic'
            },
            tooltips: {
                mode: 'index',
                intersect: false,
            },
            hover: {
                mode: 'nearest',
                intersect: true
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Month'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Value'
                    }
                }]
            }
        }
    };

    /*************************
        Different Point Sizes
   *************************/
    var config7 = {
        type: 'line',
        data: {
            labels: ["January", "February", "March", "April", "May", "June", "July"],
            datasets: [{
                label: "dataset - big points",
                data: [
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor()
                ],
                backgroundColor: window.chartColors.red,
                borderColor: window.chartColors.red,
                fill: false,
                borderDash: [5, 5],
                pointRadius: 15,
                pointHoverRadius: 10,
            }, {
                label: "dataset - individual point sizes",
                data: [
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor()
                ],
                backgroundColor: window.chartColors.blue,
                borderColor: window.chartColors.blue,
                fill: false,
                borderDash: [5, 5],
                pointRadius: [2, 4, 6, 18, 0, 12, 20],
            }, {
                label: "dataset - large pointHoverRadius",
                data: [
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor()
                ],
                backgroundColor: window.chartColors.green,
                borderColor: window.chartColors.green,
                fill: false,
                pointHoverRadius: 30,
            }, {
                label: "dataset - large pointHitRadius",
                data: [
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor()
                ],
                backgroundColor: window.chartColors.yellow,
                borderColor: window.chartColors.yellow,
                fill: false,
                pointHitRadius: 20,
            }]
        },
        options: {
            maintainAspectRatio: false,
            responsive: true,
            legend: {
                position: 'bottom',
            },
            hover: {
                mode: 'index'
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Month'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Value'
                    }
                }]
            },
            title: {
                display: true,
                text: 'Line Chart - Different point sizes'
            }
        }
    };

    /*************************
        Chart Stacked
    *************************/
    var barChartData = {
        labels: ["January", "February", "March", "April", "May", "June", "July"],
        datasets: [{
            label: 'Dataset 1',
            backgroundColor: window.chartColors.red,
            data: [
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor()
            ]
        }, {
            label: 'Dataset 2',
            backgroundColor: window.chartColors.blue,
            data: [
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor()
            ]
        }, {
            label: 'Dataset 3',
            backgroundColor: window.chartColors.green,
            data: [
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor()
            ]
        }]
    };

    /*************************
       window onload
   *************************/

    function getRandomColor() {
        var letters = '0123456789ABCDEF'.split('');
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
    window.onload = function () {
        if ($('#canvas1').exists()) {
            var ctx1 = document.getElementById("canvas1").getContext("2d");
            window.myLine1 = new Chart(ctx1, config);

            var desde = $("#desde").val();
            var hasta = $("#hasta").val();
            var totalesAnio = [{ total: "" }];
            $.ajax({
                url: "./ventascomparativolineaanio",
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                type: "POST",
                data: { desde: desde, hasta: hasta },
                beforeSend: function () {
                    console.log("cargando");
                },
                success: function (dataResp) {
                    var anio = "";
                    var a = 0;
                    let suma1 = 0;
                    $.each(dataResp, function (i, item) {

                        if (i == 0) {
                            anio = item.Año;
                        }
                        if (item.Año != anio) {
                            anio = item.Año;
                            a++;
                        }
                        window.myLine1.data.datasets[a].data.push(item.Importe);
                        window.myLine1.update();
                        suma1 += item.Importe;
                    });

                }
            });

            console.log(totalesAnio);

        }
        if ($('#canvas2').exists()) {
            var ctx2 = document.getElementById("canvas2").getContext("2d");
            window.myLine2 = new Chart(ctx2, config2);


            var desde = $("#desde").val();
            var hasta = $("#hasta").val();
            $.ajax({
                url: "./ventaslinea",
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                type: "POST",
                data: { desde: desde, hasta: hasta },
                beforeSend: function () {
                    console.log("cargando");
                },
                success: function (dataResp) {
                    $.each(dataResp, function (i, item) {
                        window.myLine2.data.labels.push((item.Linea));
                        window.myLine2.data.datasets[0].label = "Importe";
                        window.myLine2.data.datasets[0].data.push(item.Importe);
                        window.myLine2.data.datasets[1].label = "Tickets";
                        window.myLine2.data.datasets[1].data.push(item.Tickets);
                        window.myLine2.data.datasets[2].label = "Artículos";
                        window.myLine2.data.datasets[2].data.push(item.Articulos);
                        window.myLine2.update();
                    });

                }
            });

        }//fin canvas 2

        if ($('#canvas3').exists()) {
            var ctx3 = document.getElementById("canvas3").getContext("2d");
            window.myLine3 = new Chart(ctx3, config3);

            var desde = $("#desde").val();
            var hasta = $("#hasta").val();
            $.ajax({
                url: "./ventasucursal",
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                type: "POST",
                data: { desde: desde, hasta: hasta },
                beforeSend: function () {
                    console.log("cargando");
                },
                success: function (dataResp) {
                    $.each(dataResp, function (i, item) {
                        window.myLine3.data.labels.push((item.Column1));
                        window.myLine3.data.datasets[0].data.push((item.Importe));
                        window.myLine3.data.datasets[0].backgroundColor.push(getRandomColor());
                        window.myLine3.data.datasets[0].label.push(item.Linea);

                        window.myLine3.update();
                    });

                }
            });
        }

        if ($('#canvas4').exists()) {
            var ctx4 = document.getElementById("canvas4").getContext("2d");
            window.myLine4 = new Chart(ctx4, config4);
        }

        if ($('#canvas5').exists()) {
            var chartEl = document.getElementById("canvas5");
            var chart = new Chart(chartEl, {
                type: "line",
                data: lineChartData,
                options: {
                    maintainAspectRatio: false,
                    responsive: true,
                    title: {
                        display: true,
                        text: "Custom Tooltips using Data Points"
                    },
                    tooltips: {
                        enabled: false,
                        mode: 'index',
                        intersect: false,
                        custom: customTooltips
                    }
                }
            });
        };
    }

    if ($('#canvas6').exists()) {
        var ctx6 = document.getElementById("canvas6").getContext("2d");
        window.myLine6 = new Chart(ctx6, config6);
    }

    if ($('#canvas7').exists()) {
        var ctx7 = document.getElementById("canvas7").getContext("2d");
        window.myLine7 = new Chart(ctx7, config7);
    }

    if ($('#canvas8').exists()) {
        var ctx8 = document.getElementById("canvas8").getContext("2d");
        window.myBar = new Chart(ctx8, {
            type: 'bar',
            data: barChartData,
            options: {
                maintainAspectRatio: false,
                responsive: true,
                title: {
                    display: true,
                    text: "Bar Chart - Stacked"
                },
                tooltips: {
                    mode: 'index',
                    intersect: false
                },
                responsive: true,
                scales: {
                    xAxes: [{
                        stacked: true,
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                }
            }
        });
    }

    //Inicio chart Bodas
    if ($('#canvasWedding').exists()) {
        var ctx3 = document.getElementById("canvasWedding").getContext("2d");
        window.LineWedding = new Chart(ctx3, configWeddingChart);

        var ctxWeddingHotel2 = document.getElementById("canvasWeddingHotel2").getContext("2d");
        window.LineWeddingHotel2 = new Chart(ctxWeddingHotel2, configWeddingBar);

        var desde = $("#desde").val();
        var hasta = $("#hasta").val();
        $.ajax({
            url: "./ventasBodas",
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            type: "POST",
            data: { desde: desde, hasta: hasta },
            beforeSend: function () {

            },
            success: function (dataResp) {

                let response = JSON.parse(dataResp);

                $.each(response.group_by_date, function (i, item) {
                    window.LineWedding.data.labels.push(item.Fecha_Servicio);
                    window.LineWedding.data.datasets[0].label = "Importe";
                    window.LineWedding.data.datasets[0].data.push(item.Importe);

                    window.LineWedding.update();
                });

                $.each(response.total_wedding_per_day, function (i, item) {
                    window.LineWedding.data.datasets[1].label = "Total de bodas";
                    window.LineWedding.data.datasets[1].data.push(item.venta_por_dia);
                    window.LineWedding.update();
                });

                $.each(response.sales_by_hotel, function (i, item) {
                    window.LineWeddingHotel2.data.labels.push(item.Hotel_Nombre);
                    window.LineWeddingHotel2.data.datasets[0].label = "Total bodas";
                    window.LineWeddingHotel2.data.datasets[0].backgroundColor.push(getRandomColor());
                    window.LineWeddingHotel2.data.datasets[0].data.push(item.total_bodas);
                    window.LineWeddingHotel2.data.datasets[1].label = "Importe";
                    window.LineWeddingHotel2.data.datasets[1].backgroundColor.push(getRandomColor());
                    window.LineWeddingHotel2.data.datasets[1].data.push(item.Importe);

                    window.LineWeddingHotel2.update();
                });

            }
        });
    }
    // Fin chart bodas

})(jQuery);

